import { render, staticRenderFns } from "./Conversor.vue?vue&type=template&id=b3156a64&scoped=true&"
import script from "./Conversor.vue?vue&type=script&lang=ts&"
export * from "./Conversor.vue?vue&type=script&lang=ts&"
import style0 from "./Conversor.vue?vue&type=style&index=0&id=b3156a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3156a64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b3156a64', component.options)
    } else {
      api.reload('b3156a64', component.options)
    }
    module.hot.accept("./Conversor.vue?vue&type=template&id=b3156a64&scoped=true&", function () {
      api.rerender('b3156a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Importar/Conversor/Conversor.vue"
export default component.exports